import GlobalBase from '../global-base';

import _ from 'lodash';

/**
 * The JS controller for the pricing table block.
 */
class PricingTableBlock extends GlobalBase {

    cache() {
        this.pricingTable = document.getElementById( 'pricing-table' );
        this.prices = this.pricingTable ? this.pricingTable.querySelectorAll('.price') : null;
    }

    docReady() {
        this.cache();

        // If no pricing table is set in the DOM, bail.
        if ( ! this.pricingTable ) {
            return null;
        }

        const select = document.getElementById('currency');
        const periodTogglers = document.getElementById( 'period-togglers' );
        const togglerButtons = periodTogglers ? periodTogglers.querySelectorAll( '.button' ) : [];
        const ctaButtons =  document.getElementsByClassName( 'cta-button' );
        const featureItems = document.querySelectorAll( '.feature-item.monthly-price, .feature-item.yearly-price' );
        const perYearElements =  document.getElementsByClassName( 'paid-once-per-year' );


        togglerButtons.forEach( button => {
            button.addEventListener( 'click', ( event ) => {
                try {
                    // Set active states.
                    togglerButtons.forEach( button => button.classList.remove( 'is-active' ) );
                    event.target.classList.add( 'is-active' );
                    // Toggle the prices.
                    const targetClass = _.get( event, 'target.dataset.show', null );
                    const currencyValue = select.options[ select.options.selectedIndex ].value || '';
                    const currencyClass = `price--${currencyValue.toLowerCase()}`;
                    this.showPrices( targetClass, currencyClass );
                    this.showElements( targetClass, [...Array.from(ctaButtons), ...Array.from(perYearElements), ...Array.from(featureItems)] );
                }
                catch (e) {
                    console.error( e );
                }
            } )
        } )

        select.onchange = ( event ) => {
            try {
                const currencyValue = _.get( event, 'target.value', '' );
                const currencyClass = `price--${currencyValue.toLowerCase()}`
                const activeButtonIdx = _.findIndex( togglerButtons, button => button.classList.contains( 'is-active' ) );
                const targetClass = _.get( togglerButtons[ activeButtonIdx ], 'dataset.show', null );
                this.showPrices( targetClass, currencyClass );
            } catch (e) {
                console.error(e);
            }
        };
    }

    showPrices( targetClass, currencyClass ) {
        if ( ! targetClass || ! currencyClass ) {
            return null;
        }

        this.prices.forEach( priceElem => {
            if ( priceElem.classList.contains( targetClass ) && priceElem.classList.contains( currencyClass ) ) {
                priceElem.classList.add( 'is-inline' );
            }
            else {
                priceElem.classList.remove( 'is-inline' );
            }
        } );
    }

    showElements( targetClass, elements ) {
      if ( ! targetClass ) {
          return null;
      }

      elements.forEach((element) => {
          if ( element.classList.contains( targetClass ) ) {
              element.classList.remove( 'hidden' );
          } else { element.classList.add( 'hidden' ); }
      })
    };
}

// Export the singleton.
export default new PricingTableBlock();
